import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar, faStarHalfStroke } from "@fortawesome/free-solid-svg-icons";
import './Review.css';

const Review = ({ reviewData }) => {
  const fullStar = <FontAwesomeIcon icon={faStar} style={{ color: "gold" }} />;
  const customStyle = {
    width: '50%',
    borderRadius: '50%'
  }
  const { name, title, picture, rating, review } = reviewData;
  return (
    <div className="col mt-5">
      {" "}
      <div className=" d-flex flex-column gap-3 mb-5 shadow p-4 rounded align-items-center">
        <div className="user-details text-center ">
          <img src={picture} alt="" style={customStyle} />
          <h5 className="mt-2">{name}</h5>
        </div>
        <h6>
          Rating:{" "}
          {rating === 5 ? (
            <span>
              {fullStar}
              {fullStar}
              {fullStar}
              {fullStar}
              {fullStar}
            </span>
          ) : (
            <span>
              {fullStar}
              {fullStar}
              {fullStar}
              {fullStar}
              <FontAwesomeIcon
                style={{ color: "gold" }}
                icon={faStarHalfStroke}
              />
            </span>
          )}
        </h6>
        <div></div>
        {/* {rating === 5 ? <FontAwesomeIcon icon={faStar} /> : ""} */}
        <div className="review ">
          <h5 title={title}>
            {title.length < 25 ? title : title.slice(0, 25) + "..."}
          </h5>
          <hr />
          <p title={review}>
            {review.length < 180 ? review : review.slice(0, 200) + "..."}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Review;
